<template>
  <div class="cpxz">
    <div class="banner ">
      <img class="banner_img" src="../../static/img/cp_banner.png" alt="">
    </div>
    <div class="content">
      <!-- 导航列表 -->
      <div class="content_nav w1200" :class="{ active_nav : nav }">
        <nav v-for="(item,i) in cpxz" :key="i" @click="active = i">
          <li :class="{ active: active === i }">{{item.value}}</li>
        </nav>
      </div>
      <div class="content_text">
      </div>
      <!-- 四个列表里的内容区 -->
      <div class="content_text1">
        <div class="content_js w1200" v-if="active === 0">
          <div v-for="(item,i) in fzkj" :key="i" class="cont_img">
            <img :src="item.img1" alt="">
            <h3>{{item.text}}</h3>
            <p>{{item.text1}}</p>
            <div class="img_yy" @click="$router.push({path:item.path })">
              <img src="../../static/img/cp_dianjijt.png" alt="">
            </div>
          </div>
        </div>
        <div class="content_js content_js1 w1200" v-if="active === 1">
          <div v-for="(item,e) in xhwb" :key="e" class="cont_img ">
            <img :src="item.xbimg" alt="">
            <h3>{{item.text}}</h3>
            <p>{{item.text1}}</p>
            <div class="img_yy" @click="$router.push({path:item.path })">
              <img src="../../static/img/cp_dianjijt.png" alt="">
            </div>
          </div>
        </div>
        <div class="content_js content_js1 w1200" v-if="active === 2">
          <div v-for="(item,i) in fsps" :key="i" class="cont_img">
            <img :src="item.xbimg" alt="">
            <h3>{{item.text}}</h3>
            <p>{{item.text1}}</p>
            <div class="img_yy" @click="$router.push({path:item.path })">
              <img src="../../static/img/cp_dianjijt.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cpxz',
  data () {
    return {
      nav: false,
      active: 0,
      cpxz: [
        {
          value: '飞猪科技'
        },
        {
          value: '协和万邦'
        },
        {
          value: '方胜磐石'
        }
      ],
      fzkj: [
        {
          img1: require('../../static/img/cp_rb.png'),
          text: '热保APP',
          text1: '热保APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=0'

        },
        {
          img1: require('../../static/img/cp_lhb.png'),
          text: '联合保APP',
          text1: '联合保APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=1'

        },
        {
          img1: require('../../static/img/cp_xe.png'),
          text: '小二APP',
          text1: '小二保险APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=2'

        },
        {
          img1: require('../../static/img/cp_zz.png'),
          text: '紫尊保APP',
          text1: '紫尊保APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=3'

        },
        {
          img1: require('../../static/img/cp_lcb.png'),
          text: '利车保APP',
          text1: '利车保APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=4'

        },
        {
          img1: require('../../static/img/cp_thb.png'),
          text: '太慧宝APP',
          text1: '太慧宝APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=5'

        },
        {
          img1: require('../../static/img/cp_dlb.png'),
          text: '鼎龙宝APP',
          text1: '鼎龙宝APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=6'

        },
        {
          img1: require('../../static/img/cp_xbb.png'),
          text: '协保宝APP',
          text1: '协保宝APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=7'

        },
        {
          img1: require('../../static/img/cp_fz.png'),
          text: '飞猪保险APP',
          text1: '飞猪保险APP，专为保险代理人打造...',
          path: '/cpfz?page=3&id=8'
        }
      ],
      xhwb: [
        {
          xbimg: require('../../static/img/sx.png'),
          text: '寿险',
          text1: '生活可靠有力的保障',
          path: '/cpxh?page=3&id=0'

        },
        {
          xbimg: require('../../static/img/ywx.png'),
          text: '意外险',
          text1: '随时随地、无时无刻的保护',
          path: '/cpxh?page=3&id=1'

        },
        {
          xbimg: require('../../static/img/hone_jcx.png'),
          text: '家财险',
          text1: '房屋、家庭财产等均受保护',
          path: '/cpxh?page=3&id=2'

        },
        {
          xbimg: require('../../static/img/cx.png'),
          text: '车险',
          text1: '车辆险、附加险与交强险全面保护',
          path: '/cpxh?page=3&id=3'

        }
      ],
      fsps: [
        {
          xbimg: require('../../static/img/gdym.png'),
          text: '光大永明人寿',
          text1: '吉瑞宝两全保险',
          path: '/cpxq?page=3&id=0',
          id: '0'
        },
        {
          xbimg: require('../../static/img/tfqq.png'),
          text: '同方全球人寿',
          text1: '康健一生（多倍保）终身重大疾病保险',
          path: '/cpxq?page=3&id=1',
          id: '1'

        },
        {
          xbimg: require('../../static/img/xtrs.png'),
          text: '信泰人寿',
          text1: '千万传承终身寿险B 款',
          path: '/cpxq?page=3&id=2',
          id: '2'

        },
        {
          xbimg: require('../../static/img/gyas.png'),
          text: '工银安盛人寿',
          text1: '御享人生重大疾病保险',
          path: '/cpxq?page=3&id=3',
          id: '3'

        },
        {
          xbimg: require('../../static/img/ccrs.png'),
          text: '长城人寿',
          text1: '康健人生重大疾病保险',
          path: '/cpxq?page=3&id=4',
          id: '4'

        },
        {
          xbimg: require('../../static/img/hxrs.png'),
          text: '华夏人寿',
          text1: '华夏福两全保险',
          path: '/cpxq?page=3&id=5',
          id: '5'

        },
        {
          xbimg: require('../../static/img/jkrs.png'),
          text: '君康人寿',
          text1: '多倍保重大疾病保险',
          path: '/cpxq?page=3&id=6',
          id: '6'

        },
        {
          xbimg: require('../../static/img/fxlh.png'),
          text: '复星联合',
          text1: '康乐一生重大疾病保险（B款升级款）',
          path: '/cpxq?page=3&id=7',
          id: '7'

        }
      ]
    }
  },
  mounted () {
    if(this.isMobile()) {
          this.$router.push({ path: "/products" });
        } else {
          this.$router.push({ path: "/cpxz?page=3" });
        }
    let navH = 540
    window.onscroll = _ => {
      var SH = document.body.scrollTop || document.documentElement.scrollTop
      // console.log(SH)
      if (SH >= (navH - 20)) {
        this.nav = true
      } else {
        this.nav = false
      }
    }
  },
   methods: {
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
    position: relative;
    background: #014fa2;
    width: 100%;
    max-width: 19.2rem;
    margin: 0 auto;
    .content_nav {
        height: 1.15rem;
        color: #5f5f5f;
        line-height: 1.15rem;
        background-color: #eee;
        font-size: .22rem;
        display: flex;
        justify-content: space-around;
        position: absolute;
        left: 50%;
        transform: translateX(-50%) translateY(-0.45rem);
        li {
            cursor: pointer;
        }
    }
    .active {
        color: red;
        cursor: pointer;
    }
    .active_nav {
        position: fixed;
        top: .1rem;
        left: 50%;
        z-index: 1;
        transform: translateX(-50%) translateY(0);
    }
    .content_text {
        margin: 0 auto;
        max-width: 13.90rem;
        background-color: #024ea2;
        padding-top: 1.05rem;
    }
    .content_text1 {
        margin: 0 auto;
        width: 100%;
        max-width: 13.90rem;
        // height: 1400px;
        box-sizing: border-box;
        background-color: #f2f2f2;
        padding: .6rem 0;
        .content_js {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            .cont_img {
                width: 3.60rem;
                margin: .25rem .2rem;
                box-shadow: 0px 0px 3px 2px #dbdbdb;
                text-align: center;
                position: relative;
                cursor: pointer;
                // box-sizing: border-box;
                h3 {
                    line-height: .4rem;
                    color: #292929;
                    font-size: .26rem;
                    font-weight: 400;
                    padding-top: .2rem;
                }
                p {
                    font-size: .2rem;
                    color: #8d8d8d;
                    padding-bottom: .25rem;
                }
                .img_yy {
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    box-sizing: border-box;
                    background-color: rgba(255, 255, 255, 0.3);
                    border: 2px solid #db0b23;
                    opacity: 0;
                    transition: all 0.5s;
                }
            }
            .cont_img:hover > .img_yy {
                opacity: 1;
            }
        }
        .content_js1 {
            display: flex;
            justify-content: flex-start;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Cpxz.vue